import { Shark, View } from "shark-mvc";

import templateContent from "./visit-edit.html";
import followup_list_and_form from "../../_shark_templates/components/followup-list-and-form.html";

import followUpComponent from "../../components/followUp/followUpComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { quotationEditView } from "../../_shark_jaws/views/quotationEditView";
import visitListView from "./visitListView";
import { visitManager } from "../../_shark_jaws/managers/visitManager";

class VisitEditView extends View {
	constructor() {
		super("visitEditView");

		this.setTemplate(templateContent);
	}

	afterRender () {
		const sectorSelect = document.querySelector(`[data-sh-prop="prospectSector"]`);

		if (sectorSelect) {
			sectorSelect.querySelector(`[value="Geodrena"]`) ? sectorSelect.querySelector(`[value="Geodrena"]`).disabled = true : false;
			sectorSelect.querySelector(`[value="Green Paving"]`) ? sectorSelect.querySelector(`[value="Green Paving"]`).disabled = true : false;
		}
	}
	backToListBtn_clickHandler () {
		Shark.openPage(visitListView);
	}

	beforeLoad () {
		let currVisit = Shark.get("currVisit");

		if (!currVisit) {
			currVisit = Shark.getInstance("Visit");
			// if (currVisit.sentDocumentsGuids.length > 0) {
			// 	documentManager.getByGuidList(currVisit.sentDocumentsGuids);
			// }
		}
		
		followUpComponent.set("targetItem", currVisit);
		window.scrollTo(0, 0);
	}

	createQuotationBtn_clickHandler () {
		Shark.openPage(quotationEditView);
	}

	init () {
		this.addComponents([followUpComponent, mainNavComponent]);
		
		Shark.__templateMap.followup_list_and_form = followup_list_and_form;

		Shark.set({
			currVisitDocumentList: Shark.get("currVisitDocumentList") || [],
		});

		this.set({
			__htmlTitle: "Dettagli Report | IPM HUB"
		});
	}

	saveVisitBtn_clickHandler () {
		visitManager.save(Shark.get("currVisit"));
	}
}

const visitEditView = new VisitEditView();

Shark.registerView(visitEditView);

export default visitEditView;
